import * as types from "./types"
import http from "@/utils/http"
import {initOption} from "@/components/chart/ChartJS";

let state = {
  chargeTotalData: {},
  chartFlag: false,
  chartOption:{},
  chargeDetailData:{},
  monthlyCarStat: {},
  temporaryCarStat: {},
  storedCarStat: {}
}
let actions = {
  [types.CHARGEDAYTOTAL] (context, params) {
    http.post('p-app-day-total-charge', params).then(res => {
      if(res.data){
        state.chargeTotalData = res.data
      } else {
        state.chargeTotalData = {
          cnt:0,
          amnt: 0
        }
      }

    })
  },

  [types.DAYCHARGETREND] (context, params) {
    state.chartFlag = false
    state.chartOption = {}
    http.post('p-app-day-charge-trend', params).then(res => {
      if(res.data){
        state.chartOption = initOption(res.data,"date","amnt")
      }
      state.chartFlag = true
    })
  },

  [types.DAYRECORDTOTAL] (context, params) {
    http.post('p-app-day-record-total', params).then(res => {
      if(res.data){
        state.chargeDetailData = res.data
        console.log(state.chargeDetailData)
      }
    })
  },

  [types.CHARGEMONTHTOTAL] (context, params) {
    http.post('p-app-month-total-charge', params).then(res => {
      if(res.data){
        state.chargeTotalData = res.data
      } else {
        state.chargeTotalData = {
          cnt:0,
          amnt: 0
        }
      }

    })
  },

  [types.MONTHCHARGETREND] (context, params) {
    http.post('p-app-month-charge-trend', params).then(res => {
      if(res.data){
        state.chartOption = initOption(res.data,"date","amnt")
      }
      state.chartFlag = true
    })
  },

  [types.MONTHRECORDTOTAL] (context, params) {
    http.post('p-app-month-record-total', params).then(res => {
      if(res.data){
        state.chargeDetailData = res.data
      }
    })
  },

  // Daily car type statistics
  [types.DAYMONTHLYCARSTAT] (context, params) {
    http.post('p-app-day-monthly-car-stat', params).then(res => {
      if(res.data){
        state.monthlyCarStat = res.data
      }
    })
  },

  [types.DAYTEMPORARYCARSTAT] (context, params) {
    http.post('p-app-day-temporary-car-stat', params).then(res => {
      if(res.data){
        state.temporaryCarStat = res.data
      }
    })
  },

  [types.DAYSTOREDCARSTAT] (context, params) {
    http.post('p-app-day-stored-car-stat', params).then(res => {
      if(res.data){
        state.storedCarStat = res.data
      }
    })
  },

  // Monthly car type statistics
  [types.MONTHMONTHLYCARSTAT] (context, params) {
    http.post('p-app-month-monthly-car-stat', params).then(res => {
      if(res.data){
        state.monthlyCarStat = res.data
      }
    })
  },

  [types.MONTHTEMPORARYCARSTAT] (context, params) {
    http.post('p-app-month-temporary-car-stat', params).then(res => {
      if(res.data){
        state.temporaryCarStat = res.data
      }
    })
  },

  [types.MONTHSTOREDCARSTAT] (context, params) {
    http.post('p-app-month-stored-car-stat', params).then(res => {
      if(res.data){
        state.storedCarStat = res.data
      }
    })
  }

}
let mutations = {
  [types.RECHARGETREND] (state, data) {
    state.chartOption = {}
    state.chartFlag = false
  },
}


export default { state, actions, mutations }



// WEBPACK FOOTER //
// ./src/store/app/bill/index.js